import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { Router } from '@angular/router';
import { LocationStrategy } from "@angular/common";
import { SharedHttp } from '../../../services/http-client.service';
/**
 * Wallet invitation Modal Component
 */
let WalletInvitationModalComponent = class WalletInvitationModalComponent {
    constructor(httpClient, sanitizer, router, location, themeService) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.router = router;
        this.location = location;
        this.themeService = themeService;
        this.secondColor = '';
        this.accentColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.successColor = '';
        this.backColor = '';
        this.themeService.getTheme().subscribe((data) => {
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.backColor = this.themeService.getStyleAttribute('modal_back_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
        location.onPopState(() => {
            this.closeModal();
        });
    }
    ngOnInit() {
    }
    closeModal() {
        document.documentElement.style.overflowY = '';
        this.modal.destroy();
    }
    closeAndGoToHome() {
        this.modal.destroy();
        this.router.navigateByUrl('');
    }
    goToWallet() {
        this.modal.destroy();
        this.router.navigateByUrl('wallet/cryptocurrencies');
    }
    dontShowThisMessage() {
        this.modal.destroy();
        this.httpClient.post('user/dontshowwalletmassage', {}).subscribe((data) => {
            this.closeModal();
        });
    }
};
WalletInvitationModalComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: Router },
    { type: LocationStrategy },
    { type: WebsiteThemeService }
];
WalletInvitationModalComponent = __decorate([
    Component({
        selector: 'ecd-wallet-invitation-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./wallet-invitation-modal.component.html")).default
    })
], WalletInvitationModalComponent);
export { WalletInvitationModalComponent };
